module.exports = __webpack_public_path__ + "static/img/long_press_send.ad924265.png";